import loadableWithRetry from '../common/loadableWithRetry'

const ThankYou = loadableWithRetry(() => import('./ThankYou'))

export default ThankYou;
